import React from 'react'
import styled from 'styled-components'
import { ButtonChip, Box, Button, Text } from 'pcln-design-system'
import { Close } from 'pcln-icons'
import PropTypes from 'prop-types'

const StyledBox = styled(Box)`
  padding: 12px 0;
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  gap: 8px;

  ${(props) => props.theme.mediaQueries.sm} {
    padding: 12px 8px;
  }
}
`
/* istanbul ignore next */
export function ListingFilterChips({ filtersLists, clearFilters }) {
  return (
    <StyledBox>
      {filtersLists &&
        filtersLists.map((filter) => (
          <ButtonChip selected size='sm' onClick={filter?.onClick} key={filter.value}>
            <Text fontWeight='regular' pt='4px' pb='4px'>
              {filter.primaryLabel}
            </Text>
            <Close color='primary' ml={2} size={16} />
          </ButtonChip>
        ))}
      {filtersLists && filtersLists.length > 0 && (
        <Button variation='link' onClick={clearFilters} size='large'>
          Clear Filters
        </Button>
      )}
    </StyledBox>
  )
}

ListingFilterChips.propTypes = {
  filtersLists: PropTypes.array,
  clearFilters: PropTypes.func,
}
